import { useEffect, useState } from "react";
import { SelectorProcessTypeConstants } from "./Componentes/SelectorProcessTypeConstants";
import { PrintJson } from "../../theme/Component/PrintJson";
import useModal, { MODAL_LG, MODAL_md } from "../../theme/Component/hooks/useModal";
import { Modal } from "../../theme/Component/Modal";
import { ContractService } from "../../../core/services/ContractService";
import { _single } from "../../../core/services/dataBean/EntityCatalog";
import { BasicSwitch } from "../../theme/Component/BasicSwitch";

interface Props {
    config: any;
    onChange: any;
    
}
export const DocumentTemplateEditor = ({ config, onChange }: Props) => {


    const service = new ContractService();

    const [document, setDocument] = useState<any>({
        IDProcessType: 0,
        IDDocument: 0,
        DocumentName: '',
        Multiple: false
    });
    const [lista, setLista] = useState<any>([]);
    const modal = useModal("Documentos", MODAL_LG);

    useEffect(() => {
        console.log(config);

        if (config) {
            try {
                setDocument(JSON.parse(config));
                console.log(JSON.parse(config));

            } catch (error) {
            }
        }
    }, [])

    useEffect(() => {
        getHiringModalityDocumentRender();
    }, [document.IDProcessType])

   

    const getHiringModalityDocumentRender = () => {

        let filter: any = {};
        if (document.IDProcessType > 0) {
            filter.ProcessType = document.IDProcessType
        }
        _single.spinner(true);
        service.getHiringModalityDocumentRender(null, null, filter).subscribe(
            (resp: any) => {


                if (resp.DataBeanProperties.ObjectValue.DataBeanProperties.List) {
                    setLista(resp.DataBeanProperties.ObjectValue.DataBeanProperties.List);
                    let lis = resp.DataBeanProperties.ObjectValue.DataBeanProperties.List;
                    if (lis.length > 0) {
                        putDocument(lis[0].DataBeanProperties.IDHiringModalityDocument);
                        setDocument({ ...document, "DocumentName": lis[0].DataBeanProperties.Name, "IDDocument": lis[0].DataBeanProperties.IDHiringModalityDocument });
                        onChange(lis[0].DataBeanProperties)
                    }
                } else {
                    setLista([])
                }
                _single.spinner(false);

            }
        );
    }

    const putDocument = (idDoc: any) => {
        

        const filtro = lista.filter(item => item.DataBeanProperties.IDHiringModalityDocument == idDoc);

        if(filtro.length>0)
        {
            const element = filtro[0];
            setDocument({ ...document, "DocumentName": element.DataBeanProperties.Name, "IDDocument": element.DataBeanProperties.IDHiringModalityDocument });
            if(onChange)
            {
                onChange(element.DataBeanProperties);
            }
        }
        
        
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <label>Documento</label>
                <input type="text" name="doc" className="form-control" value={document.DocumentName} readOnly onClick={() => { modal.open() }} />
            </div>

            <div className="col-md-12">
                <Modal modal={modal.modal} updateModal={modal.setModal}>
                    <div className="row">
                        <div className="col-md-6">
                            <SelectorProcessTypeConstants idSelector={document.IDProcessType} onChange={(e) => { setDocument({ ...{}, "IDProcessType": e }) }} />
                        </div>
                        <div className="col-md-6">
                            <label>Documento</label>
                            <select name="docid" className="form-control" value={document.IDDocument} onChange={(e) => { putDocument(e.target.value) }}>

                                {lista.map((item: any, index: any) => {
                                    return (
                                        <option value={item.DataBeanProperties.IDHiringModalityDocument}>{item.DataBeanProperties.Name}</option>
                                    )
                                })

                                }
                            </select>
                        </div>
                    </div>
                </Modal>
            </div>

        </div>
    )
}
